import { ProjectUser } from "@Projects/Model";

export interface ICommand { }


export class CreateProjectUsersCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.ProjectUsers.Commands.CreateProjectUsersCommandV1, TCh.Domain.ProjectUsers';

	Id: string;
	WorkspaceId: number;
	ProjectUsers: ProjectUser[];

	constructor(workspaceId: number, projectId: number, projectUsers: ProjectUser[])
	{
		this.Id = projectId.toString();
		this.WorkspaceId = workspaceId;
		this.ProjectUsers = projectUsers;
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.ProjectUsers.Commands.CreateProjectUsersCommandV1, TCh.Domain.ProjectUsers'
	}
}

export class DeleteProjectUserCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.ProjectUsers.Commands.DeleteProjectUserCommandV1, TCh.Domain.ProjectUsers';

	Id: string;
	WorkspaceId: number;
	ProjectUserId: number;

	constructor(workspaceId: number, projectId: number, projectUserId: number)
	{
		this.Id = projectId.toString();
		this.WorkspaceId = workspaceId;
		this.ProjectUserId = projectUserId;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.ProjectUsers.Commands.DeleteProjectUserCommandV1, TCh.Domain.ProjectUsers'
	}
}

export class UpdateProjectUserCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.ProjectUsers.Commands.UpdateProjectUserCommandV1, TCh.Domain.ProjectUsers';

	Id: string;
	WorkspaceId: number;
	ProjectUserId: number;
	NewName: string;
	NewEmail: string;
	NewTags: string[];
	OldName: string;
	OldEmail: string;
	OldTags: string[];

	constructor(workspaceId: number, projectId: number, projectUserId: number, newName: string, newEmail: string, newTags: string[], oldName: string, oldEmail: string, oldTags: string[])
	{
		this.Id = projectId.toString();
		this.WorkspaceId = workspaceId;
		this.ProjectUserId = projectUserId;
		this.NewName = newName;
		this.NewEmail = newEmail;
		this.NewTags = newTags;
		this.OldName = oldName;
		this.OldEmail = oldEmail;
		this.OldTags = oldTags;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.ProjectUsers.Commands.UpdateProjectUserCommandV1, TCh.Domain.ProjectUsers'
	}
}

export class ResetProjectUserAccessTokenCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.ProjectUsers.Commands.ResetProjectUserAccessTokenCommandV1, TCh.Domain.ProjectUsers';

	Id: string;
	WorkspaceId: number;
	ProjectUserId: number;

	constructor(workspaceId: number, projectId: number, projectUserId: number)
	{
		this.Id = projectId.toString();
		this.WorkspaceId = workspaceId;
		this.ProjectUserId = projectUserId;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.ProjectUsers.Commands.ResetProjectUserAccessTokenCommandV1, TCh.Domain.ProjectUsers'
	}
}

export class ArchiveProjectUserCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.ProjectUsers.Commands.ArchiveProjectUserCommandV1, TCh.Domain.ProjectUsers';

	Id: string;
	WorkspaceId: number;
	ProjectUserId: number;

	constructor(workspaceId: number, projectId: number, projectUserId: number)
	{
		this.Id = projectId.toString();
		this.WorkspaceId = workspaceId;
		this.ProjectUserId = projectUserId;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.ProjectUsers.Commands.ArchiveProjectUserCommandV1, TCh.Domain.ProjectUsers'
	}
}

export class UnarchiveProjectUserCommandV1 implements ICommand
{
	$type: string = 'TCh.Domain.ProjectUsers.Commands.UnarchiveProjectUserCommandV1, TCh.Domain.ProjectUsers';

	Id: string;
	WorkspaceId: number;
	ProjectUserId: number;

	constructor(workspaceId: number, projectId: number, projectUserId: number)
	{
		this.Id = projectId.toString();
		this.WorkspaceId = workspaceId;
		this.ProjectUserId = projectUserId;
	}

	static matchType(cmd: any)
	{
		return cmd.$type == 'TCh.Domain.ProjectUsers.Commands.UnarchiveProjectUserCommandV1, TCh.Domain.ProjectUsers'
	}
}



